import React from 'react';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useModal } from 'src/state/modal';

const StyledText = styled('p', {
  fontSize: '28px',
  lineHeight: '34px',
});

const StyledModalBody = styled('div', {
  textAlign: 'center',
  padding: '30px 40px 30px 40px',
});

export const ReactivateConfirmationModal = () => {
  const { modals } = useModal.state();
  const { toggleModal } = useModal.actions();

  const handleClose = () => {
    toggleModal({
      key: 'confirmation-modal',
      isOpen: false,
    });
  };

  return (
    <Modal
      id="reactivate-training-confirmation-modal"
      isOpen={modals['confirmation-modal']}
      onClose={handleClose}
      size={500}
      offset="200px"
    >
      <StyledModalBody>
        <div>
          <StyledText>
            You have successfully
            <br />
            activated the training tips.
          </StyledText>
        </div>
        <Button
          id="close-button"
          aria-label="Click to close confirmation modal"
          onClick={handleClose}
          styles={{
            button: (base) => {
              return {
                ...base,
                display: 'table',
                margin: '0 auto',
                width: '58%',
              };
            },
          }}
        >
          Close
        </Button>
      </StyledModalBody>
    </Modal>
  );
};
